import styled from "styled-components";
import axiosConfig from "services/api/axiosConfiig";
import { useDispatch } from "react-redux";
import { authActions } from "redux/store/auth-slice";
import { useRef, useState } from "react";
import { IoIosMail } from "react-icons/io";
import MSIcon from "assets/images/mssymbol.png";
import { RiLockPasswordFill } from "react-icons/ri";
import { useHistory, Link } from "react-router-dom";
import PrimaryButton from "components/shared/Buttons/PrimaryButton";
import { CgPassword } from "react-icons/cg";
import { loginRequest } from '../../../authConfig';
import GridLoader from "react-spinners/GridLoader";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { SPECSAVERS_GREEN } from "constants";



const LoadingDataContainer = styled.div`
  width: 100vw;
  position: relative;
  height: 400px;
  top: 10vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 2;
`;

const LoadingText = styled.p`
  margin-top: 25px;
  font-size: 2rem;
  font-weight: bold;
  color: ${SPECSAVERS_GREEN};
`;

const Index = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const emailInputRef = useRef();
  const passwordInputRef = useRef();
  const codeInputRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [showCodeWarning, setShowCodeWarning] = useState(false);
  const [loginCodeValue, setLoginCodeValue] = useState("");

  const { instance,inProgress } = useMsal();

  const  isAuthenticated = useIsAuthenticated()

  const handleLoginRedirect = () => {
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    // instance.acquireTokenRedirect(loginRequest).catch((error) => console.log(error));
  };

  if(isAuthenticated){
    instance.acquireTokenSilent({
      scopes:["User.read"],
      account: instance.getActiveAccount()
    }).then(tokenResponse=>{
      axiosConfig.post(`/azure/login`, {
        IdToken:tokenResponse.idToken
      }).then(loginResponse=>{

        const {data} = loginResponse;

        localStorage.setItem("token", data.accessToken);
        localStorage.setItem("userId", data.userId);
        localStorage.setItem("refresh", data.refreshToken);
        loginSuccessHandler(data.userId, data.accessToken);
      })
    })
  }else{
    handleLoginRedirect();
  }

  const loginSuccessHandler = async (userId, accessToken) => {
    const config = {
      method: "get",
      headers: {
        Authorization: accessToken,
      },
    };

    await axiosConfig(`/users/${userId}`, config)
      .then(function (response) {
        dispatch(
          authActions.loginHandler({
            accessToken: accessToken,
            userId: userId,
            accountType: response.data.accountType,
            market: response.data.marketType,
          })
        );
        dispatch(authActions.isLoggedInToggle());
        history.replace("/");
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  

  return (
    <>
      <LoadingDataContainer>
          <GridLoader color={SPECSAVERS_GREEN} />
          <LoadingText>Signing you in...</LoadingText>
      </LoadingDataContainer>
    </>
    
  );
};

export default Index;
